<template>
  <div>
    <page-header title="ویرایش ویژگی محصول"></page-header>

    <crud-generator v-if="specification" :fields="fields" @submit="submit" :current-values="specification"
                    name="specifications"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "UpdateSpecification",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [
        {
          name: 'fa_name',
          label: 'نام',
          cols: 4,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'en_name',
          label: 'Name',
          cols: 4,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'type',
          label: 'Type',
          cols: 4,
          type: 'select',
          select_items: [
            {text: 'بله / خیر', value: 'BOOLEAN'},
            {text: 'عدد', value: 'NUMBER'},
            {text: 'متن', value: 'STRING'},
          ],
          select_value: 'value',
          select_text: 'text',
        },
        {
          name: 'searchable',
          label: 'قابل جستجو',
          cols: 2,
          type: 'checkbox',
        },
      ],
      specification: null,
    }
  },

  mounted() {
    this.getSpecification()
  },

  methods: {
    getSpecification() {
      this.$store.dispatch("singleSpecification", this.$route.params.id)
          .then((res) => {
            this.specification = res.data
          })
    },

    submit(values) {
      this.$store.dispatch("updateSpecification", {data: values, identifier: this.$route.params.id})
          .then(() => {
            this.$router.push('/specifications');
          })
    },
  }
}
</script>

<style scoped>

</style>